import React from 'react';
import { Badge, Box, Container, Heading, SimpleGrid, Text, VStack } from '@chakra-ui/react';

const cards = [
  {
    stat: '15 biases analyzed',
    title: 'Pre-sale visibility your CRM does not give you',
    body:
      'Layer behavioral signals on top of your existing customer base. A client showing loss-aversion patterns after a market dip can surface to the RM before the next call.',
  },
  {
    stat: '5 role dashboards',
    title: 'One client base, four operating views',
    body:
      'Admin sees coverage, RM sees who to call, Compliance sees missing suitability evidence, and Portfolio Adviser sees drift. Each role reviews the same uploaded data through a different operating lens.',
  },
  {
    stat: '30-day trial, no card',
    title: 'Start in the playground, ship under your brand later',
    body:
      'Solo for one adviser, Team to coordinate a firm, Business to control the whole book, Enterprise when FinanSee must run inside your systems. Integration scope and timeline are agreed before any rollout.',
  },
];

const WhyFinansee = () => {
  return (
    <Box as="section" bg="brand.quantumBg" py={{ base: 16, md: 24 }} borderTopWidth="1px" borderColor="brand.quantumBorder">
      <Container maxW="container.xl">
        <Badge
          bg="rgba(0, 212, 170, 0.1)"
          color="brand.quantumAccent"
          borderRadius="full"
          px={3}
          py={1}
          mb={5}
          letterSpacing="0.15em"
          textTransform="uppercase"
        >
          Why FinanSee
        </Badge>
        <Heading
          as="h2"
          size="xl"
          mb={4}
          color="white"
          fontWeight="bold"
          textAlign={{ base: 'center', md: 'left' }}
        >
          Why financial institutions choose FinanSee
        </Heading>
        <Text
          fontSize="lg"
          color="brand.quantumMuted"
          maxW="4xl"
          mb={{ base: 8, md: 12 }}
          textAlign={{ base: 'center', md: 'left' }}
        >
          FinanSee is built for teams that need practical signals, role-specific queues,
          and a path from self-serve trial to controlled enterprise rollout.
        </Text>

        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={{ base: 6, md: 8 }}>
          {cards.map((card) => (
            <VStack
              key={card.title}
              bg="brand.quantumCard"
              p={6}
              borderRadius="2xl"
              boxShadow="0 18px 48px rgba(0, 0, 0, 0.28)"
              borderWidth="1px"
              borderColor="brand.quantumBorder"
              align="start"
              spacing={4}
            >
              <Text fontSize="xs" fontWeight="800" color="brand.quantumAccent" textTransform="uppercase" letterSpacing="0.12em">
                {card.stat}
              </Text>
              <Text fontWeight="800" fontSize="xl" color="white">
                {card.title}
              </Text>
              <Text color="brand.quantumMuted" fontSize="md">
                {card.body}
              </Text>
            </VStack>
          ))}
        </SimpleGrid>

        <Text mt={8} color="brand.quantumSubtle" fontSize="sm">
          These are operating hypotheses to evaluate with your team. Customer outcomes remain to be measured.
        </Text>
      </Container>
    </Box>
  );
};

export default WhyFinansee;
